export const FADE_ANIMATION_DURATION = 300;
export const VIEW_ALL_COMPONENT = 'view_all';
